import React, { Component } from 'react'
import {
    Button,
    Avatar,
    List,
    Card,
    Pagination,
    Space,
    Input,
    DatePicker,
    Form,
    Row,
    Col,
    Popconfirm,
    Spin,
} from "antd";
import {
    DeleteOutlined,
    QuestionCircleOutlined,
    SearchOutlined,
} from '@ant-design/icons';
import { user } from "../../../../service";
import { useNavigate } from 'react-router-dom';
import { withParams, PAGINATION } from '../../../../utils/util'
import { connect } from 'react-redux';
import dayjs from "dayjs";
import { message } from 'antd/lib';

const initial = {
    search: null,
    startTime: null,
    endTime: null,
}
class UserDemandView extends Component {
    searchForm = React.createRef()
    state = {
        queryParams: initial,
        pagination: PAGINATION,
        loading: false,
        dataSource: [],
        rangePresets: [
            {
                label: '最近1天',
                value: [dayjs().add(-1, 'd'), dayjs()],
            },
            {
                label: '最近7天',
                value: [dayjs().add(-7, 'd'), dayjs()],
            },
            {
                label: '最近14天',
                value: [dayjs().add(-14, 'd'), dayjs()],
            },
            {
                label: '最近30天',
                value: [dayjs().add(-30, 'd'), dayjs()],
            },
        ],
    }


    // 首次加载数据
    componentDidMount() {
        this.fetch()
    }

    // 获取列表数据
    fetch = async (params = { pagination: PAGINATION }) => {
        this.setState({ loading: true })
        const { current, pageSize } = params.pagination
            , { queryParams } = this.state
            , { data: { total, records } } = await user.apiDemand.getList(queryParams)
        this.setState({
            loading: false,
            dataSource: records,
            pagination: {
                ...PAGINATION,
                current,
                pageSize,
                total: total
            }
        })
    }

    // 查询
    onSearch = (params = {}) => {
        console.log(params);
        this.setState({
            queryParams: {
                ...this.state.queryParams,
                search: params.search,
                startTime: params.date && dayjs(params.date[0]).format('YYYY-MM-DD'),
                endTime: params.date && dayjs(params.date[1]).format('YYYY-MM-DD')
            }
        }, () => {
            this.fetch()
        })
    }

    // 删除
    delete = async (id) => {
        try {
            await user.apiDemand.del(id)
            message.success("删除成功")
            this.fetch()
        } catch (error) {
            console.log(error);
        }

    }

    render() {
        const { dataSource, total, pagination, rangePresets, loading } = this.state
            , { searchForm, fetch, onSearch } = this
            , searchOperate = () => {
                return (
                    <Space
                        style={{ display: 'flex', justifyContent: 'end', paddingBottom: 16 }}
                    >
                        <Space.Compact>
                            <Button
                                icon={<SearchOutlined />}
                                type="primary"
                                htmlType="submit"
                            >
                                查询
                            </Button>
                        </Space.Compact>
                    </Space>
                )
            }
        return (
            <Card
                className='border-none'
                title="需求管理"
                extra={
                    <Space>

                        <Button type='primary' onClick={() => this.props.navigate(`/usercenter/demand/add/${'-1'}`)}>发布</Button>

                    </Space>
                }
            >
                <Form
                    ref={searchForm}
                    name="farming.task.search.form"
                    onFinish={onSearch}
                    labelCol={{ xl: { span: 7 }, xxl: { span: 4 } }}
                >
                    <Row gutter={40}>
                        <Col span={8}>
                            <Form.Item
                                name="search"
                                label="查询"
                            >
                                <Input
                                    placeholder='请输入标题/内容/品种分类等'
                                    allowClear={true}
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                name="date"
                                label="发布日期"
                            >
                                <DatePicker.RangePicker presets={rangePresets} />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            {
                                searchOperate()
                            }
                        </Col>

                    </Row>
                </Form>


                <Spin spinning={loading}>
                    <List
                        size="large"
                        itemLayout="horizontal"
                        dataSource={dataSource}
                        renderItem={(item, index) => (
                            <List.Item
                                actions={[
                                    <Button
                                        type='link'
                                        onClick={() => this.props.navigate(`/usercenter/demand/add/${item.id}`)}
                                    >编辑</Button>,

                                    <Popconfirm
                                        onConfirm={() => this.delete(item.id)}
                                        title="此操作将永久删除该信息, 是否继续？"
                                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                                    >
                                        <Button
                                            type="link"
                                            style={{ padding: 0 }}
                                            danger
                                        >删除</Button>
                                    </Popconfirm>
                                ]}
                            >
                                <List.Item.Meta
                                    onClick={() => this.props.navigate(`/serviceshall/details/${item.id}`)}
                                    style={{ cursor: 'pointer' }}
                                    avatar={<Avatar
                                        shape="square"
                                        size={78}
                                        src={this.props.serverUrl + item.coverImage}
                                    />}
                                    title={<div style={{ fontSize: '18px' }}>{item.title}</div>}
                                    description={<>
                                        <div>{item.content}</div>
                                        <div>{item.createDate}</div>
                                    </>}
                                />
                            </List.Item>
                        )}
                    />
                </Spin>



                <Pagination
                    className='m-lg flex end'
                    total={total}
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    showTotal={(total) => `共 ${total} 条`}
                    onChange={(value) => fetch(value)}
                />
            </Card>
        )
    }
}


const mapStateToProps = (state) => ({
    serverUrl: state.siteInfo.serverUrl
})
const ConnectedView = connect(mapStateToProps)(UserDemandView);

export default withParams(ConnectedView, () => { }, () => { }, useNavigate)
